module.exports = __webpack_public_path__ + "img/7.d375a17.png";